import type { Guide } from '../types';

/**
 * S-21.10-21 — kabotaż liczy TMS (scenariusz e2e 22, BR-FTL-15). Przełącznik niczego nie dokłada na ekran,
 * tylko zdejmuje — decyzja integratora fali C: jeden krok opisowy na rekomendacjach, bez wyjątku.
 */
export const guide: Guide = {
  flagKey: 'cabotageByTms',
  title: 'Kabotaż liczy TMS — bez naszych ostrzeżeń',
  whatItDoes:
    'Kabotaż i karencję po nim („cooling off”) liczy TMS, więc rekomendacje pojazdów już ich nie dublują. Przy pojazdach nie ma ostrzeżeń o serii kabotaży, przekroczonym limicie ani karencji, a z „Na jakiej podstawie” znika punkt „Kabotaż”. Dotyczy obu kierunków — pojazdów dla zlecenia i zleceń dla pojazdu; kolejność listy i wykluczenia się nie zmieniają.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-21.10-21'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'dowolne zlecenie do zaplanowania w FTL',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'vehicle-suggestions-scroll',
      mockupTestId: 'ftl-zlecenie-rekomendacje',
      title: 'Rekomendacje bez kabotażu',
      description:
        'W uwagach przy pojazdach nie ma już ostrzeżeń o kabotażu i karencji, a rozwinięte „Na jakiej podstawie” nie ma punktu „Kabotaż”. Limity kabotażu sprawdza TMS.',
      action: 'Kliknij „Pokaż rekomendowane pojazdy”, a przy pojeździe ikonę „Na jakiej podstawie”.',
      recorder: {
        account: 'master',
        demo: { kind: 'order', number: 'DEMO/2026/09/001' },
        actions: [
          { kind: 'clickButton', name: 'Pokaż rekomendowane pojazdy' },
          { kind: 'clickButton', name: 'Na jakiej podstawie' },
        ],
      },
    },
  ],
};
